// GAPI mutations
import types from '../../types';

export default {
  [types.GET_PLACE]: (state) => {
    state.gapi = true;
  },
};
